import { useState } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/authStore';

interface LoginFormValues {
  username: string;
  password: string;
}

interface LoginResponse {
  username: string;
  role: string;
  must_change_password: boolean;
}

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setUser = useAuthStore((s) => s.setUser);

  const onFinish = async (values: LoginFormValues) => {
    setLoading(true);
    try {
      const { data } = await api.post<LoginResponse>('/auth/login', values);
      setUser(data);
      if (data.must_change_password) {
        navigate('/account/change-password', { replace: true });
      } else {
        navigate(searchParams.get('next') || '/overview', { replace: true });
      }
    } catch (err) {
      const status = (err as { response?: { status?: number } })?.response?.status;
      const code = (err as { response?: { data?: { code?: string } } })?.response?.data?.code;
      if (status === 401) {
        message.error('用户名或密码错误');
      } else if (status === 403 && code === 'ACCOUNT_DISABLED') {
        message.error('账号已停用，请联系管理员');
      } else {
        message.error('登录失败，请稍后重试');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f0f2f5',
        padding: 16,
      }}
    >
      <Card title="GAC VOC Monitor 登录" style={{ width: 'min(100% - 32px, 400px)', maxWidth: 400 }}>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input autoComplete="username" />
          </Form.Item>
          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
